'use client';

/**
 * Navigates to `url` via a POST request. Plain function (no React) so it can be
 * called from non-component code such as the query-client error handler.
 *
 * A POST (not a GET link) cannot be triggered by a simple cross-site GET such
 * as an auto-loading image or iframe (CSRF). The request is a same-origin form
 * submission, so the browser sends the `bb-pl` SameSite=Strict cookie the
 * gateway uses to authorise the request, and the server's redirect / auto-posting
 * form renders as a normal top-level navigation. No body or CSRF token is sent
 * from the client.
 */
export const postNavigate = (url: string) => {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = url;
  document.body.appendChild(form);
  form.submit();
  form.remove();
};
